import { json } from 'aurelia-fetch-client';
import { autoinject } from 'aurelia-framework';
import { ResponseHandler } from '../../utils/response-handler';
import { ApiService } from '../../utils/api-service';

@autoinject
export class MunicipalityService {
	constructor(private api: ApiService, private responseHandler: ResponseHandler) { };

	private customerMunicipalities: { [id: string]: CustomerMunicipality[] } = {};

	getMunicipalities(): Promise<Municipality[]> {
		return this.api.fetchJson('municipalities');
	}

	getMunicipalitiesForFiscalYear(fiscalYearId: string): Promise<CustomerMunicipality[]> {
		return this.api.fetchJson(`fiscalyears/${fiscalYearId}/municipalities`)
			.then(data => { 
				this.customerMunicipalities[fiscalYearId] = data;
				return data;
			});
	}

	addMunicipalityForFiscalYear(fiscalYearId: string, customerMunicipality: AddCustomerMunicipality): Promise<Response> {
		return this.api.fetch(`fiscalyears/${fiscalYearId}/municipalities`, {
			method: 'post',
			body: json(customerMunicipality)
		});
	}

	removeMunicipalityFromFiscalYear(fiscalYearId: string, customerMunicipality: CustomerMunicipality) {
		return this.api.fetch(`fiscalyears/${fiscalYearId}/municipalities/${customerMunicipality.name}`, {
			method: 'delete'
		});
	}

	getCustomerMunicipalityTypes(): Promise<CustomerMunicipalityType[]> {
		return this.api.fetchJson(`customer-municipality-types`);
	}

	getCurrentMunicipalities(customerId: string): Promise<CustomerMunicipality[]> {
		return this.api.fetchJson(`municipalities/${customerId}/current-municipalities`);
	}
}

export interface Municipality {
	name: string;
	code: number;
	type: string;
}

export class CustomerMunicipality {
	municipalityId: string;
	customerMunicipalityId: string;
	name: string;
	type: string;
	code: number;
}

export interface CustomerMunicipalityType {
	value: number;
	name: string;
}

export interface AddCustomerMunicipality {
	municipalityId: string;
	municipalityType: number;
}

